import React from "react";
import "./style/SpinnerComponent.scss";

const SpinnerComponent = () => {
    return(<div className="spinner"></div>)
}

export default SpinnerComponent;